{
  "confirmDialog": {
    "confirm": "Confirm",
    "cancel": "Cancel"
  },
  "spinner": {
    "loading": "Loading"
  },
  "toast": {
    "dismiss": "Dismiss"
  }
}
